module.exports = __webpack_public_path__ + "static/scale-model-of-historic-ships-in-baltimore-in-baltimore-maryland-192b3de54dc4481e7116465312136eca.png";